import type { CharacterSlotId } from '@momentum/shared';

/**
 * The board's player token, drawn flat. Lives here rather than inside a single panel because more
 * than one surface needs it: the voice strip had it privately, so the mini-game transition screen
 * could not import it and drew its own black glyph instead — six players rendered two different
 * ways in the same session. Anything showing who is in the room uses this.
 *
 * Colours match `momentumBoard3d.tsx`'s runtime palette, so a berry on the board and a berry in a
 * card are the same character.
 */
const PALETTE: Record<CharacterSlotId, string> = {
  'lilac-square': '#bea0ed', 'blue-oval': '#6c9ff1', 'coral-triangle': '#f4928e',
  'yellow-hexagon': '#f4ce68', 'green-diamond': '#86ccb2', 'charcoal-circle': '#ecafd5',
};

export function BerryAvatar({ slot, size = 34, className }: { slot: CharacterSlotId | null; size?: number; className?: string }) {
  return <svg className={className} aria-hidden="true" viewBox="0 0 36 36" width={size} height={size}>
    <ellipse cx="18" cy="32" rx="10" ry="2" fill="#203c58" opacity=".1" />
    <path d="M9 27C4 25 3 18 5 13C6 10 8 8 11 8C11 3 17 2 20 6C24 3 29 6 28 10C33 12 34 18 32 24C31 28 27 31 22 31H14C12 31 10 30 9 27Z" fill={slot ? PALETTE[slot] : '#bea0ed'} />
    <path d="M8 14C8 11 10 10 12 11" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" opacity=".34" />
    <ellipse cx="13.5" cy="18" rx="1.6" ry="2.3" fill="#17202a" />
    <ellipse cx="23" cy="18" rx="1.6" ry="2.3" fill="#17202a" />
    <path d="M16 23Q18.3 25 20.5 23" fill="none" stroke="#17202a" strokeWidth="1.5" strokeLinecap="round" />
  </svg>;
}
